import * as Style from '../Sidebar/style';

function ActiveUser({ participants, activeUser, setActiveUser }) {
  return (
    <Style.Field>
      <Style.Label htmlFor="active-user">Active user</Style.Label>
      <Style.Select
        id="active-user"
        disabled={!participants.length}
        value={activeUser}
        onChange={e => {
          setActiveUser(e.target.value);
        }}
      >
        {participants.map(participant => (
          <option key={participant} value={participant}>
            {participant}
          </option>
        ))}
      </Style.Select>
    </Style.Field>
  );
}

export default ActiveUser;
